import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CountUp from "react-countup";

// Import modal
import ResolveIssueModal from "../modals/ResolveIssueModal";

const SupportDashboard = () => {
  const routes = all_routes;
  const [selectedIssue, setSelectedIssue] = useState<any>(null);

  // Mock issues data
  const mockIssues = [
    {
      id: 1,
      ticketId: "TKT-2024-001",
      title: "Login System Delays",
      description:
        "Users experiencing slow login response times during peak hours",
      category: "Technical",
      priority: "Critical",
      status: "Open",
      reporterName: "John Smith",
      reporterEmail: "john.smith@school.edu",
      reporterRole: "Teacher",
      reportDate: "2024-07-23 09:15",
      timeline: [
        { date: "2024-07-23 09:15", action: "Issue reported by user" },
        { date: "2024-07-23 09:30", action: "Escalated to technical team" },
        { date: "2024-07-23 10:00", action: "Investigation started" },
      ],
    },
    {
      id: 2,
      ticketId: "TKT-2024-002",
      title: "Document Download Failed",
      description:
        "Unable to download transfer certificates from parent portal",
      category: "Feature",
      priority: "High",
      status: "In Progress",
      reporterName: "Sarah Johnson",
      reporterEmail: "sarah.j@parent.com",
      reporterRole: "Parent",
      reportDate: "2024-07-23 08:45",
      timeline: [
        { date: "2024-07-23 08:45", action: "Issue reported by parent" },
        { date: "2024-07-23 09:00", action: "Assigned to support team" },
      ],
    },
    {
      id: 3,
      ticketId: "TKT-2024-003",
      title: "Grade Calculation Error",
      description:
        "Math grades showing incorrect averages in student dashboard",
      category: "Technical",
      priority: "Medium",
      status: "Open",
      reporterName: "Mike Wilson",
      reporterEmail: "mike.wilson@school.edu",
      reporterRole: "Student",
      reportDate: "2024-07-22 16:30",
      timeline: [
        { date: "2024-07-22 16:30", action: "Issue reported by student" },
        { date: "2024-07-23 08:00", action: "Initial review completed" },
      ],
    },
  ];

  const handleResolveIssue = (issue: any) => {
    setSelectedIssue(issue);
  };

  const getPriorityColor = (priority: string) => {
    switch (priority.toLowerCase()) {
      case "critical":
        return "badge-soft-danger";
      case "high":
        return "badge-soft-warning";
      case "medium":
        return "badge-soft-info";
      case "low":
        return "badge-soft-success";
      default:
        return "badge-soft-secondary";
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Dashboard Content */}
          <div className="row">
            {/* Welcome Card */}
            <div className="col-12">
              <div className="card bg-purple">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-white">
                      <h3>Support Center</h3>
                      <p>Monitor system health and assist users</p>
                    </div>
                    <div className="avatar avatar-lg">
                      <i className="ti ti-headset text-white fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Pending Requests Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-warning-transparent me-2">
                      <i className="ti ti-clock-pause fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-warning">
                          <CountUp end={47} />
                        </h2>
                        <span className="badge bg-warning">Pending</span>
                      </div>
                      <p>Pending Requests</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      High: <span className="text-danger fw-semibold">12</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Normal:{" "}
                      <span className="text-warning fw-semibold">35</span>
                    </p>
                  </div>
                  <Link
                    to={routes.allDocumentRequests}
                    className="btn btn-warning btn-sm mt-2 w-100"
                  >
                    View Requests
                  </Link>
                </div>
              </div>
            </div>

            {/* User Access Logs Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-info-transparent me-2">
                      <i className="ti ti-shield-lock fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-info">
                          <CountUp end={1248} />
                        </h2>
                        <span className="badge bg-info">Today</span>
                      </div>
                      <p>User Access Logs</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Active:{" "}
                      <span className="text-success fw-semibold">892</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Locked: <span className="text-danger fw-semibold">8</span>
                    </p>
                  </div>
                  <Link
                    to={routes.supportUserAccess}
                    className="btn btn-info btn-sm mt-2 w-100"
                  >
                    Access Logs
                  </Link>
                </div>
              </div>
            </div>

            {/* Reported Bugs Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-danger-transparent me-2">
                      <i className="ti ti-bug fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-danger">
                          <CountUp end={14} />
                        </h2>
                        <span className="badge bg-danger">Open</span>
                      </div>
                      <p>Reported Bugs</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Critical:{" "}
                      <span className="text-danger fw-semibold">3</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Minor:{" "}
                      <span className="text-warning fw-semibold">11</span>
                    </p>
                  </div>
                  <Link
                    to={routes.reportedIssues}
                    className="btn btn-danger btn-sm mt-2 w-100"
                  >
                    View Issues
                  </Link>
                </div>
              </div>
            </div>

            {/* System Status Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-success-transparent me-2">
                      <i className="ti ti-server fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-success">
                          <CountUp end={99} />%
                        </h2>
                        <span className="badge bg-success">Healthy</span>
                      </div>
                      <p>System Status</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Uptime:{" "}
                      <span className="text-success fw-semibold">99.8%</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Load: <span className="text-info fw-semibold">Low</span>
                    </p>
                  </div>
                  <Link to="#" className="btn btn-success btn-sm mt-2 w-100">
                    System Health
                  </Link>
                </div>
              </div>
            </div>

            {/* Open Issues */}
            <div className="col-xxl-8 col-xl-12">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h4 className="card-title">
                    Open Issues Requiring Attention
                  </h4>
                  <Link
                    to={routes.reportedIssues}
                    className="btn btn-primary btn-sm"
                  >
                    View All Issues
                  </Link>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Ticket</th>
                          <th>Issue</th>
                          <th>Reporter</th>
                          <th>Priority</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mockIssues.map((issue) => (
                          <tr key={issue.id}>
                            <td>
                              <span className="text-primary fw-medium">
                                {issue.ticketId}
                              </span>
                            </td>
                            <td>
                              <div>
                                <h6 className="mb-1">{issue.title}</h6>
                                <small className="text-muted">
                                  {issue.description.substring(0, 50)}...
                                </small>
                              </div>
                            </td>
                            <td>
                              <div>
                                <span className="fw-medium">
                                  {issue.reporterName}
                                </span>
                                <br />
                                <small className="text-muted">
                                  {issue.reporterRole}
                                </small>
                              </div>
                            </td>
                            <td>
                              <span
                                className={`badge ${getPriorityColor(
                                  issue.priority
                                )}`}
                              >
                                {issue.priority}
                              </span>
                            </td>
                            <td>
                              <span className="badge badge-soft-warning">
                                {issue.status}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex gap-2">
                                <button
                                  className="btn btn-sm btn-success"
                                  data-bs-toggle="modal"
                                  data-bs-target="#resolveIssueModal"
                                  onClick={() => handleResolveIssue(issue)}
                                >
                                  <i className="ti ti-check me-1"></i>Resolve
                                </button>
                                <button className="btn btn-sm btn-outline-primary">
                                  <i className="ti ti-eye me-1"></i>View
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="col-xxl-4 col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Quick Actions</h4>
                </div>
                <div className="card-body">
                  <div className="d-grid gap-2">
                    <Link
                      to={routes.supportUserAccess}
                      className="btn btn-info"
                    >
                      <i className="ti ti-shield-lock me-2"></i>Unlock User
                      Account
                    </Link>
                    <Link
                      to={routes.allDocumentRequests}
                      className="btn btn-warning"
                    >
                      <i className="ti ti-file-text me-2"></i>Review Requests
                    </Link>
                    <Link to={routes.reportedIssues} className="btn btn-danger">
                      <i className="ti ti-bug me-2"></i>Report Issue
                    </Link>
                    <div className="dropdown">
                      <button
                        className="btn btn-success dropdown-toggle w-100"
                        type="button"
                        data-bs-toggle="dropdown"
                      >
                        <i className="ti ti-tools me-2"></i>System Tools
                      </button>
                      <ul className="dropdown-menu w-100">
                        <li>
                          <Link className="dropdown-item" to="#">
                            Reset Passwords
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="#">
                            Clear Cache
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="#">
                            Backup Data
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* System Performance */}
            <div className="col-12">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h4 className="card-title">System Performance</h4>
                  <span className="badge bg-success">
                    All Systems Operational
                  </span>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="text-center">
                        <div className="progress-circle mb-2">
                          <span className="text-success fs-2">99.8%</span>
                        </div>
                        <p className="mb-0">Server Uptime</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="text-center">
                        <div className="progress-circle mb-2">
                          <span className="text-info fs-2">45%</span>
                        </div>
                        <p className="mb-0">CPU Usage</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="text-center">
                        <div className="progress-circle mb-2">
                          <span className="text-warning fs-2">67%</span>
                        </div>
                        <p className="mb-0">Memory Usage</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="text-center">
                        <div className="progress-circle mb-2">
                          <span className="text-success fs-2">892</span>
                        </div>
                        <p className="mb-0">Active Users</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Resolve Issue Modal */}
      <ResolveIssueModal issue={selectedIssue} />
    </>
  );
};

export default SupportDashboard;
